export default __webpack_public_path__ + "static/media/01_gallery.6ef24965.jpg";